<template>
  <div
    class="groups_wrap dialog-app-panel"
    :class="showGroupsPanel ? 'dialog-show' : ''"
  >
    <appPanel
      class="app-panel"
      :width="700"
      :isExpand="showGroupsPanel"
      title="选择权限组"
      @cancel="handleCloseGroupsPanel"
    >
      <div class="choose-people">
        <div v-for="(item, index) in checkPeople" class="people" :key="index">
          <el-tag size="small" @close="handleCloseTag(item)" closable>{{
            item.thirdRightGroupName
          }}</el-tag>
        </div>
      </div>
      <ioc-table
        ref="multipleTable"
        :data="tableData"
        :option="constData.groupsTable"
        :page="constData.page"
        @selection-change="handleSelectionChange"
        @search-change="handleSearchChange"
        @search-reset="handleSearchReset"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </ioc-table>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleCloseGroupsPanel"
          type="info"
          :loading="subLoading"
        >
          {{ subLoading ? "提交中" : "取消" }}
        </el-button>
        <el-button
          type="primary"
          :loading="subLoading"
          @click="handleSaveGroupsPanel"
        >
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
  </div>
</template>

<script>
import { api } from "../api.js";
import appPanel from "@src/components/business/app-panel/index";
import utils from "@src/common/utils";
import { groupsTable } from "../options/groupsTable.js";
export default {
  components: {
    appPanel,
  },
  props: {
    personnelCode: {
      type: String,
      default: "",
    },
    showGroupsPanel: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showGroupsPanel: {
      handler(val) {
        if (val) {
          this.constData.page.pageNum = 1;
          this.constData.page.pageSize = 10;
          this.getGroupsList(true);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      constData: {
        groupsTable: groupsTable(),
        page: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        searchForm: {},
      },
      tableData: [],
      checkPeople: [],
      subLoading: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleCloseGroupsPanel(type = false) {
      this.checkPeople = [];
      this.$refs.multipleTable.$refs.multipleTable.clearSelection();
      this.$emit("handleCloseGroupsPanel", type);
    },
    // 获取个人权限
    queryGroups() {
      let params = {
        pageNum: 1,
        pageSize: 1000,
        personnelCode: this.personnelCode,
      };
      this.$fetch(api.queryGroup, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent || "获取个人权限数据失败");
          return;
        }
        this.checkPeople = [];
        res.returnObj.list.forEach((item) => {
          this.handleCheck(item);
          // let checkList = this.tableData.filter((el) => {
          //   return el.thirdRightGroupCode == item.thirdRightGroupCode;
          // });
          // this.checkPeople.push([0]);
          // this.handleCheck(checkList[0]);
        });
        this.getGroupsList();
      });
    },

    // 获取全部权限组
    getGroupsList(type = false) {
      let params = {
        ...this.constData.page,
        ...this.constData.searchForm,
        searchFlag: "visitor",
        // personnelCode: this.personnelCode,
        // rightGroupType: 2,
      };
      this.$fetch(api.getGroup, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent || "获取权限组数据失败");
          return;
        }
        this.tableData = res.returnObj.list.map((el) => {
          return el;
        });
        type && this.queryGroups();
        this.constData.page.total = res.returnObj.total;
      });
    },
    handleSaveGroupsPanel() {
      if (!this.checkPeople.length) {
        this.$message.warning("请选择权限组");
        return;
      }
      let groupCode = [];
      this.checkPeople.forEach((item) => {
        groupCode.push(item.rightGroupCode);
      });
      let params = {
        personnelCode: this.personnelCode,
        // thirdRightGroupCodeList: this.groupCode,
        rightGroupCodeList: groupCode,
      };
      this.subLoading = true;
      this.$fetch(api.updateGroup, params).then((res) => {
        this.subLoading = false;
        if (res.success) {
          this.$message.success("操作成功");
          this.handleCloseGroupsPanel(true);
        } else {
          this.$message.error(res.msgContent || "添加失败");
        }
        //
      });
    },
    handleSearchChange(param) {
      this.constData.page.pageNum = 1;
      this.constData.searchForm = Object.assign({}, param);
      this.getGroupsList();
    },
    // 条件重置
    handleSearchReset() {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = 10;
      this.constData.searchForm = {};
      this.getGroupsList();
    },
    // 分页查询
    handleCurrentChange(val) {
      this.constData.page.pageNum = val;
      this.getGroupsList();
    },
    // 条数查询
    handleSizeChange(val) {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = val;
      this.getGroupsList();
    },
    // 多选
    handleSelectionChange(row) {
      console.log(row);
      this.checkPeople = [];
      row.forEach((item) => {
        this.checkPeople.push(item);
      });
    },
    handleCheck(item) {
      this.$nextTick(() => {
        this.$refs.multipleTable.$refs.multipleTable.toggleRowSelection(
          item,
          true
        );
      });
    },
    handleCloseTag(item) {
      this.$nextTick(() => {
        this.$refs.multipleTable.$refs.multipleTable.toggleRowSelection(
          item,
          false
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.groups_wrap {
  width: 100%;
  height: 100%;

  .choose-people {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 6px;

    .people {
      margin: 0px 5px 5px;
    }
  }
}
</style>
